import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable()
export class CustomPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();

  itemsPerPageLabel = 'Items per page:';
  nextPageLabel = 'Next page';
  previousPageLabel = 'Previous page';
  firstPageLabel = 'First page';
  lastPageLabel = 'Last page';

  constructor(private readonly translate: TranslateService) {
    this.translate.onLangChange.subscribe(() => {
      this.getAndInitTranslations();
    });
    this.getAndInitTranslations();
  }

  getAndInitTranslations(): void {
    this.translate
      .get([
        'Pagination.ITEMS_PER_PAGE',
        'Pagination.NEXT_PAGE',
        'Pagination.PREVIOUS_PAGE',
        'Pagination.FIRST_PAGE',
        'Pagination.LAST_PAGE',
      ])
      .subscribe((translations) => {
        this.itemsPerPageLabel = translations['Pagination.ITEMS_PER_PAGE'];
        this.nextPageLabel = translations['Pagination.NEXT_PAGE'];
        this.previousPageLabel = translations['Pagination.PREVIOUS_PAGE'];
        this.firstPageLabel = translations['Pagination.FIRST_PAGE'];
        this.lastPageLabel = translations['Pagination.LAST_PAGE'];
        this.changes.next();
      });
  }

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return this.translate.instant('Pagination.RANGE_PAGE_ZERO', { length });
    }

    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);

    return this.translate.instant('Pagination.RANGE_PAGE', {
      startIndex: startIndex + 1,
      endIndex,
      length,
    });
  };
}
